import {PEV} from "../../../common/utils";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import * as service from "./service";
import {NOT_LOADED_STATE} from "src/common/ApiCall";

export interface ManagePolicyComponentProps {
  pageTitle?: string;
  steps?: {
    title: string,
    content: JSX.Element
  }[];
  confirmationText?: string;
  buttonText?: string[];
  cancelText?: string[];
  isButtonDisabled?: boolean;
  nextStep?: () => void;
  cancelStep?: () => void;
}

export enum manageType {
  Create = "create",
  Edit = "edit",
  Delete = "delete"
}

const initialState = {
  //@ts-ignore
  policyInputRequirements: PEV(null, NOT_LOADED_STATE),
  //@ts-ignore
  createPolicy: PEV(null, NOT_LOADED_STATE),
  //@ts-ignore
  editPolicy: PEV(null, NOT_LOADED_STATE)
};

const getPolicyInputRequirements = createAsyncThunk("policyInputRequirements/get", async (policyId?: string) => {
  return await service.getPolicyInputRequirements(policyId);
});

const PolicyInputRequirementsSlice = createSlice({
  name: "policyInputRequirements",
  initialState,
  reducers: {
    resetPolicyInputRequirements(state) {
      state.policyInputRequirements = initialState.policyInputRequirements;
    },
  },
  extraReducers: {
    [getPolicyInputRequirements.pending.type]: (state) => {
      // @ts-ignore
      state.policyInputRequirements = PEV({...initialState.policyInputRequirements.value}, "Fetching policy input requirements");
    },
    [getPolicyInputRequirements.fulfilled.type]: (state, action) => {
      state.policyInputRequirements = PEV({
        data: action.payload,
      });
    },
    [getPolicyInputRequirements.rejected.type]: (state) => {
      // @ts-ignore
      state.policyInputRequirements = PEV({...initialState.policyInputRequirements.value}, null, "Error while fetching policy input requirements");
    },
  },
});

const createPolicy = createAsyncThunk("policy/create", async (data: {
  name: string,
  group: {
    type: string,
    id?: string,
    typeId?: string
  },
  systemResources: string[],
  scope: {
    name: string | undefined
  },
  actionNames: string[]
}) => {
  return await service.createPolicy(data.name, data.group, data.systemResources, data.scope, data.actionNames);
});

const editPolicy = createAsyncThunk("policy/edit", async (data: {
  name: string,
  group: {
    type: string,
    id?: string,
    typeId?: string
  },
  systemResources: string[],
  scope: {
    name: string | undefined
  },
  actionNames: string[]
  policyId: string
}) => {
  return await service.editPolicy(data.name, data.group, data.systemResources, data.scope, data.actionNames, data.policyId);
});

const CreatePolicySlice = createSlice({
  name: "createPolicy",
  initialState,
  reducers: {
    resetCreatePolicy(state) {
      state.createPolicy = initialState.createPolicy;
    },
  },
  extraReducers: {
    [createPolicy.pending.type]: (state) => {
      // @ts-ignore
      state.createPolicy = PEV({...initialState.createPolicy.value}, "Creating policy");
    },
    [createPolicy.fulfilled.type]: (state, action) => {
      state.createPolicy = PEV({
        data: action.payload,
      });
    },
    [createPolicy.rejected.type]: (state) => {
      // @ts-ignore
      state.createPolicy = PEV({...initialState.createPolicy.value}, null, "Error while creating policy");
    },
  },
});

const EditPolicySlice = createSlice({
  name: "editPolicy",
  initialState,
  reducers: {
    resetEditPolicy(state) {
      state.editPolicy = initialState.editPolicy;
    },
  },
  extraReducers: {
    [editPolicy.pending.type]: (state) => {
      // @ts-ignore
      state.editPolicy = PEV({...initialState.editPolicy.value}, "Editing policy");
    },
    [editPolicy.fulfilled.type]: (state, action) => {
      state.editPolicy = PEV({
        data: action.payload,
      });
    },
    [editPolicy.rejected.type]: (state) => {
      // @ts-ignore
      state.editPolicy = PEV({...initialState.editPolicy.value}, null, "Error while editing policy");
    },
  },
});

export const CreatePolicyReducer = CreatePolicySlice.reducer;
const {resetCreatePolicy} = CreatePolicySlice.actions;
export const CreatePolicyActions = {createPolicy, resetCreatePolicy};

export const EditPolicyReducer = EditPolicySlice.reducer;
const {resetEditPolicy} = EditPolicySlice.actions;
export const EditPolicyActions = {editPolicy, resetEditPolicy};

export const PolicyInputRequirementsReducer = PolicyInputRequirementsSlice.reducer;
const {resetPolicyInputRequirements} = PolicyInputRequirementsSlice.actions;
export const PolicyInputRequirementsActions = {getPolicyInputRequirements, resetPolicyInputRequirements};
